export enum NotificationEvents {
    isRead = 'isReadEvent',
    isUnRead = 'isUnReadEvent',
    allAreRead = 'allAreReadEvent',
}
